import { usePageTitle } from "@/hooks/usePageTitle";

export default function ReservationPage() {
  usePageTitle("Reservierung");
  return (
    <div className="py-12 md:py-24 px-4 md:px-8" data-testid="reservation-page">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold uppercase tracking-tight mb-8" style={{ fontFamily: 'Oswald' }}>
          Reserv<span style={{ color: '#fbbf24' }}>ierung</span>
        </h1>

        <div className="p-6 border border-white/10 bg-card" data-testid="event-booking-notice">
          <p className="text-base text-muted-foreground mb-4">
            Du planst eine Geburtstagsfeier, einen Firmen-Event oder eine private Veranstaltung?
          </p>
          <p className="text-base text-muted-foreground mb-4">
            Du möchtest einen Billardtisch, einen eDartautomaten oder ein Steeldart Board reservieren?
          </p>
          <p className="text-base text-muted-foreground mb-4">
            Wir bieten dir gerne den passenden Rahmen!
          </p>
          <p className="text-base text-muted-foreground mb-6">
            Anfragen bitte per Telefon oder E-Mail.
          </p>
          <div className="flex flex-wrap gap-4">
            <a href="tel:+437242216406" className="inline-flex items-center gap-2 px-4 py-2 bg-primary/10 border border-primary/20 text-sm font-medium hover:bg-primary/20 transition-colors" data-testid="event-phone">
              +43 (0)7242 216406
            </a>
            <a href="mailto:office@ninersbillard.com" className="inline-flex items-center gap-2 px-4 py-2 bg-primary/10 border border-primary/20 text-sm font-medium hover:bg-primary/20 transition-colors" data-testid="event-email">
              office@ninersbillard.com
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
